import { ReactNode, useState } from 'react'
import { Lock } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { UpgradeModal } from './UpgradeModal'
import type { BillingFeatures, BillingLimits } from '@/types'

interface LockedButtonProps {
  children: ReactNode
  feature?: keyof BillingFeatures
  limitKey?: keyof BillingLimits
  currentCount?: number
  isLocked: boolean
  orgSlug: string
  onClick?: () => void
  variant?: 'default' | 'outline' | 'ghost'
  className?: string
}

export function LockedButton({
  children,
  feature,
  limitKey,
  isLocked,
  orgSlug,
  onClick,
  variant = 'default',
  className = '',
}: LockedButtonProps) {
  const [showUpgradeModal, setShowUpgradeModal] = useState(false)

  if (!isLocked) {
    return (
      <Button variant={variant} onClick={onClick} className={className}>
        {children}
      </Button>
    )
  }

  return (
    <>
      <Button
        variant={variant}
        onClick={() => setShowUpgradeModal(true)}
        className={`relative ${className}`}
      >
        <Lock className="h-3 w-3 mr-1.5" />
        {children}
      </Button>

      <UpgradeModal
        open={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
        feature={feature}
        limitKey={limitKey}
        orgSlug={orgSlug}
      />
    </>
  )
}
